import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { NebulaConfirmationService } from '@scientifica-cms-fe/services/confirmation/confirmation.service';
import { NebulaConfirmationDialogComponent } from '@scientifica-cms-fe/services/confirmation/dialog/dialog.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    declarations: [
        NebulaConfirmationDialogComponent
    ],
    imports: [
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        CommonModule
    ],
    providers   : [
        NebulaConfirmationService
    ]
})
export class NebulaConfirmationConfig
{
    /**
     * Constructor
     */
    constructor(private _nebulaConfirmationService: NebulaConfirmationService)
    {
    }
}
